module.exports = __webpack_public_path__ + "static/media/add talent sub category.7f00ed8e.svg";